import React, { useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  CardTitle,
  CardText,
  Spinner,
  UncontrolledTooltip,
} from "reactstrap"
import { Link } from "react-router-dom"

const ReportsHome = props => {

  

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Reports | Flamingo</title>
          </MetaTags>
          <Container fluid>
            <h4>Reports</h4>
            <Row className="mt-4">

              <Col lg={4}>
                <Card>
                  <h5 className="card-header bg-transparent border-bottom">Transactions</h5>
                  <CardBody>
                    <div>
                      <ul className="list-unstyled font-weight-medium">
                        <li>
                          <Link className="text-muted py-2 d-block" to="/report-sales">
                            <i className="mdi mdi-chevron-right me-1"></i> Sales
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col lg={4}>
                <Card>
                  <h5 className="card-header bg-transparent border-bottom">Accounts</h5>
                  <CardBody>
                    <div>
                      <ul className="list-unstyled font-weight-medium">
                        <li>
                          <Link className="text-muted py-2 d-block" to="/report-day-book">
                            <i className="mdi mdi-chevron-right me-1"></i> Day Book
                          </Link>
                        </li>
                        <li>
                          <Link className="text-muted py-2 d-block" to="/report-profit">
                            <i className="mdi mdi-chevron-right me-1"></i> Profit Report
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </CardBody>
                </Card>
              </Col>
             

            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  
}

export default ReportsHome;
